/**
 * Employee API fetch: session cookie + CSRF header.
 */
import { withCsrfHeaders } from './csrf';

export function installEmployeeFetchInterceptor(): () => void {
  const original = window.fetch.bind(window);
  window.fetch = ((input: RequestInfo | URL, init?: RequestInit) => {
    try {
      const url =
        typeof input === 'string'
          ? input
          : input instanceof URL
            ? input.href
            : input.url;
      if (typeof url === 'string' && (url.includes('/api/') || url.includes('/api?'))) {
        const isAuthLogin =
          url.includes('/api/auth/employee/login')
          || url.includes('/api/auth/employee/forgot-password');
        return original(input, {
          ...init,
          headers: withCsrfHeaders(init),
          credentials: init?.credentials ?? 'include',
        }).then((res) => {
          if (res.status === 401 && !isAuthLogin) {
            window.dispatchEvent(new Event('employee-session-expired'));
          }
          return res;
        });
      }
    } catch {
      // fall through
    }
    return original(input, init);
  }) as typeof window.fetch;
  return () => {
    window.fetch = original;
  };
}
